import type { ScreenShareRepository, ScreenShareSource } from "./ScreenShareRepository.interface";
import { localApiBase } from "../../../lib/localApi";

class ApiScreenShareRepository implements ScreenShareRepository {
  private get Domain(): string {
    return localApiBase();
  }

  async getSources(): Promise<ScreenShareSource[]> {
    try {
      const response = await fetch(`${this.Domain}/api/screen-sources`, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        return [];
      }

      const data = await response.json();
      const rawSources: Array<{ id: string; name: string }> = data.sources || data.data || [];

      return rawSources.map((s) => ({
        id: s.id,
        name: s.name,
        thumbnail: `${this.Domain}/api/screen-sources/${encodeURIComponent(s.id)}/thumbnail?width=1920&height=1080`,
        width: 1920,
        height: 1080,
        type: "screen",
      }));
    } catch (error) {
      console.error("❌ Error obteniendo fuentes de pantalla (API):", error);
      return [];
    }
  }
}

export default ApiScreenShareRepository;
